import { observable, action} from "mobx";

import { MainOfferStore } from "@gp/offer";
import bettingRules from "@betting-rules";
import type { RootStore } from "@state/stores/types";
import { updateUrlParams } from "@state";
import { safeJsonParse } from "@utils/format/formatter";

export type Options = {
	type: string | "prematch";
	isLive: boolean;
	onClose?: Function;
} | null;

const DEFAULT_OPTIONS: Options = {
	type: "prematch",
	isLive: false,
	onClose: undefined,
};

export class GroupOfferStore extends MainOfferStore {
	rootStore: RootStore;
	@observable displayBettingGroup = "all";
	@observable activeSubGroup: "bet-builder" | "betting-tips" = "bet-builder";
	type: any;
	isLive: boolean;
	protected onClose: Function | undefined;

	constructor(rootStore: RootStore, options: Options = null) {
		options = Object.assign({}, DEFAULT_OPTIONS, options);
		// @ts-expect-error some of these options have default values
		super({
			customConfiguration: bettingRules,
		});

		this.rootStore = rootStore;
		this.type = options?.type || "prematch";
		this.isLive = options?.isLive || false;
		this.onClose = options?.onClose;
	}

	@action.bound
	setDisplayBettingGroup(value: string) {
		if (value !== this.displayBettingGroup) {
			this.displayBettingGroup = value;
		}
	}

	@action.bound
	setActiveSubGroup(value: "bet-builder" | "betting-tips") {
		this.activeSubGroup = value;
	}

	@action.bound
	resetDisplayBettingGroup() {
		this.displayBettingGroup = "all";
	}

	@action.bound
	readSearchParamsOnLoad() {
		const urlSearch = new URLSearchParams(window.location.search);
		const betBuilder = urlSearch.get("bb");

		if (betBuilder && safeJsonParse(betBuilder, false)) {
			this.setDisplayBettingGroup("bet-builder");
		}
	}

	@action.bound
	setBBParms(value: "true" | "") {
		updateUrlParams({ bb: value }, true);
	}
}
